import styled from "styled-components";
import { Button } from "antd";
import { LeftOutlined } from "@ant-design/icons";

import colors from "constants/palette";

export default function Index(props) {
  return (
    <BackBtn shape="round" icon={<LeftOutlined />} {...props}>
      {props.children}
    </BackBtn>
  );
}
const BackBtn = styled(Button)`
  margin-bottom: 10px;
  display: none;
  background: transparent !important;
  color: ${colors.dark};
  &:hover {
    background: transparent;
  }

  @media (max-width: 720px) {
    display: block;
  }
`;
